module.exports = __webpack_public_path__ + "img/achievements.77e1094f.svg";